import mapping from './mapping.json';

export const fontSizeDefault = mapping.strict['text-font-size'];
export const fontWeightDefault = mapping.strict['text-font-weight'];
export const fontLineHeightDefault = mapping.strict['text-line-height'];

export const fontSizeH4 = mapping.strict['text-heading-4-font-size'];

export const regularFontSize = mapping.strict['text-font-size'];
export const regularLineHeight = mapping.strict['text-line-height'];
export const regularFontWeight = mapping.strict['text-font-weight'] as '400';
